import './GuestTournamentLink.css'
import React, { useRef, memo } from 'react'
import ClipboardJS from 'clipboard'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ReactComponent as LinkCopy } from '../../icon/link_copy.svg'

const GuestTournamentLink = ({ link }) => {
	const { t } = useTranslation()
	const textRef = useRef(null)
	const buttonRef = useRef(null)

	const handleCopyClick = () => {
		const clipboard = new ClipboardJS(buttonRef.current, {
			text: () => textRef.current.textContent,
		})

		clipboard.on('success', function (e) {
			alert(t('Link copied'))

			e.clearSelection()

			clipboard.destroy()
		})

		clipboard.on('error', function (e) {
			alert(t('Error copying link'))

			clipboard.destroy()
		})

		clipboard.onClick({
			currentTarget: buttonRef.current
		})
	}

	return (
		<div className="guest-link__container">
			<Link to={link} ref={textRef} className="guest-link__text" target="_blank" rel="noopener noreferrer">
				{ link }
			</Link>

			<button
				onClick={handleCopyClick}
				ref={buttonRef}
				className="guest-link__button"
			>
				<LinkCopy className="copy-link__icon" />
			</button>
		</div>
	)
}

export const GuestLink = memo(GuestTournamentLink)